export default {
  title: 'HubRise',
  setup: {
    description: 'Share data with other applications.',
  },
  form: {
    is_menus_sync_enabled: 'Sync menu',
    is_inventory_sync_enabled: 'Sync inventory',
    is_opening_hours_sync_enabled: 'Sync opening hours',
    is_order_acceptance_mode_sync_enabled: 'Sync busy / paused status',
    variant_ref: 'Menu variant',
    variant_ref_default: 'Default',
  },
  tabs: {
    settings: 'Settings',
    service_types: 'Service types',
    payments: 'Payments',
    charges: 'Charges',
    deals: 'Deals',
    discounts: 'Discounts',
    customers: 'Customers',
  },
  customers: {
    description:
      "Erase a single customer's data on the HubRise side, for example after a data deletion request. This cannot be undone.",
    customer: 'Customer',
    placeholder: 'Search by name, email or phone…',
  },
  mapping: {
    description:
      'Map each {{provider}} entity to its matching HubRise value and name. Leave a row empty to use the {{provider}} defaults.',
    entity: '{{provider}}',
    value: 'HubRise value',
    name: 'HubRise name',
  },
  connecting: {
    title: 'Finishing the HubRise connection…',
    description: 'This takes a few seconds. Please keep this page open.',
    error_title: 'The HubRise connection is taking longer than expected',
    error_description:
      'HubRise was authorized, but the connection is not confirmed yet. Check again in a moment — if it keeps failing, start the connection again.',
  },
  buttons: {
    connect: 'Connect to HubRise',
    check_again: 'Check again',
    disconnect: 'Disconnect',
    go_to_hubrise: 'Go to HubRise',
    pull_menus: 'Pull menu',
    pull_inventory: 'Pull inventory',
    save: 'Save',
    delete_customer: 'Delete customer',
  },
  toasts: {
    connected: 'HubRise has been connected',
    connect_cancelled: 'HubRise connection was cancelled',
    connect_error: 'Failed to start the HubRise connection',
    connect_timeout: 'The HubRise connection could not be confirmed yet',
    local_changes_replaced: 'The HubRise settings were updated elsewhere — your unsaved changes were replaced',
    disconnect_success: 'HubRise has been disconnected',
    disconnect_error: 'Failed to disconnect HubRise',
    pull_menus_success: 'Menu sync has been started',
    pull_menus_error: 'Failed to pull the menu',
    pull_inventory_success: 'Inventory sync has been started',
    pull_inventory_error: 'Failed to pull the inventory',
    save_success: 'HubRise settings have been saved',
    save_error: 'Failed to save the HubRise settings',
    load_customers_error: 'Failed to load the customers',
    delete_customer_success: 'The deletion of the customer data has been requested',
    delete_customer_error: 'Failed to delete the customer data',
  },
  delete_customer_confirm: {
    title: 'Delete this customer from HubRise?',
    description: "The customer's data will be erased on the HubRise side. This cannot be undone.",
    ok: 'Delete',
    cancel: 'Cancel',
  },
  disconnect_confirm: {
    title: 'Disconnect HubRise?',
    description: 'This will stop syncing menus, inventory and orders with HubRise.',
    ok: 'Disconnect',
    cancel: 'Cancel',
  },
  connected: {
    title: 'Connected to HubRise',
    description: 'Your HubRise account is successfully linked.',
    account: 'Account',
    location: 'Location',
    catalog: 'Catalog',
    customer_list: 'Customer list',
  },
};
